import React from 'react';
import CameraOverlaysContent from './CameraOverlaysContent';
import Sheet from '../common/Sheet';
import './liveStyle.css';

/**
 * CameraOverlaysSheet — the mobile/tablet "Camera overlays" bottom sheet (#86bb5dx62). The mobile
 * equivalent of the desktop bottom-bar gear (CameraOverlaysMenu): the SAME toggle rows + Snapshot-
 * all / Reset-zoom actions, shared via CameraOverlaysContent so the two never drift. Opened by the
 * floating gear at the video grid's top-right; dismissed by the scrim, the ✕, or picking an action
 * (the two grid actions close the sheet first, then fire). Reuses the .live-sheet bottom-sheet
 * chrome that Layout/Views/Jump use.
 *
 * Props: visible, onClose(), onSnapshotAll(), onResetZoom()
 */
const CameraOverlaysSheet = ({ visible, onClose, onSnapshotAll, onResetZoom }) => {
    if (!visible) return null;
    return (
        <Sheet
            className="live-sheet live-overlays-sheet"
            scrimClassName="live-sheet-scrim"
            scrimTestId="overlays-scrim"
            title="Camera overlays"
            ariaLabel="Camera overlays"
            onClose={onClose}
        >
                <CameraOverlaysContent
                    onSnapshotAll={() => { onClose(); onSnapshotAll && onSnapshotAll(); }}
                    onResetZoom={() => { onClose(); onResetZoom && onResetZoom(); }}
                />
        </Sheet>
    );
};

export default CameraOverlaysSheet;
